// Centralised app-brand resolver. The Material Tracker is white-labelled per
// user — the visible prefix is the logged-in user's Supervisor_Name, falling
// back to their location, and finally to "ROUGEE" when neither is set.
//
// Use `getBrand(user)` for "<Prefix> Material Tracker" and `getBrandPrefix`
// for the bare prefix (e.g. for inline phrases like "the <prefix> yard").

export function getBrandPrefix(user) {
  if (!user) return "ROUGEE";
  const sup = (user.Supervisor_Name || "").trim();
  if (sup) return sup;
  const loc = (user.location || "").trim();
  if (loc) return loc;
  return "ROUGEE";
}

export function getBrand(user) {
  return `${getBrandPrefix(user)} Material Tracker`;
}
